import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { RecordAny } from '@dealstack/shared/lib/common/common';
import { ActionIcon, Tooltip, rem } from '@mantine/core';
import { ExtendedColumnDef } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { GENERIC_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds';

type Props<T extends RecordAny> = ExtendedColumnDef<T> & {
	label?: string;
};

export const createTooltipColumn = <T extends RecordAny>({
	...columnProps
}: Props<T>): ExtendedColumnDef<T> => {
	return {
		maxSize: 50,
		...columnProps,
		cell: ({ getValue }) => {
			const value = getValue() as string | number | null | undefined;
			return value ? (
				<Tooltip
					arrowSize={6}
					label={value}
					position="left"
					color={defaultTheme.v2.color.black[500]}
					radius={0}
					withArrow
					sx={{ fontSize: rem('14px'), fontWeight: 600 }}
				>
					<ActionIcon
						variant="transparent"
						aria-label={String(value)}
						data-testid={GENERIC_ELEMENT_ID.TOOLTIP_WARNING_ICON}
					>
						<Icon
							variant="information-filled"
							size="lg"
							color={defaultTheme.v2.color.warning[800]}
						/>
					</ActionIcon>
				</Tooltip>
			) : null;
		},
		enableColumnFilter: false,
		filter: () => <div />,
	};
};
